import { createReducer, on } from "@ngrx/store";
import * as ImportActions from "../imports/import-actions";
import { ImportStateInterface } from "src/app/history/models/importStateInterface";

export const initialState: ImportStateInterface = {
    isLoading: false,
    imports: [],
    error: null,
};

export const importReducers = createReducer(
    initialState, 

    // get Imports
    on(ImportActions.getImports, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(ImportActions.getImportsSuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        imports: action.imports.slice().sort((b, a) => a.createdOn?.localeCompare(b.createdOn))
    })),
    on(ImportActions.getImportsFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),
);